import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setSearchTextByPage,
  clearSearchTextByPage,
} from "../redux-store/features/providerFiltersSlice";
import { MagnifyingGlassIcon, ArrowLeftIcon } from "@heroicons/react/24/solid";
import { useLocation, useRoutes } from "react-router-dom";

const MainSearchBar = ({
  pageKey, // Unique key for the page using this component
  placeholder,
  height,
  width,
  marginRight,
  isSearchIcon,
  onSearch,
  isLoading,
  onValueChange,
  inputRef,
  searchIcon,
  className = '',
  hideBackIcon = false
}) => {
  const dispatch = useDispatch();

  // Only get the initial search text from Redux on mount
  const initialSearchValue =
    useSelector((state) => state.providersFilters.searchTextByPage[pageKey]) ||
    "";

  const [localSearch, setLocalSearch] = useState(initialSearchValue);

  const handleClearSearch = () => {
    setLocalSearch("");
    onValueChange?.('');
    dispatch(clearSearchTextByPage({ pageKey }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(setSearchTextByPage({ pageKey, searchText: localSearch }));
  };
  useEffect(() => {
    if (initialSearchValue.length === 0) {
      setLocalSearch("");
    }
  }, [initialSearchValue]);

  const onChange = (e) => {
    onValueChange?.(e.target.value);
    setLocalSearch(e.target.value);
  }

  useEffect(() => {
    setLocalSearch(initialSearchValue);
  }, [initialSearchValue, pageKey]);

  const { pathname } = useLocation();

  const routesSearchAttr =
    pathname === "/"
      ? "Vendor Name | Services | Therapeutic Area - Indications"
      : pathname === "/Documents"
        ? "Documents Name | Status | Services | Document Type"
        : pathname === "/MyDocuments"
          ? "Vendor Name | Services"
          : pathname === "/RFI/History"
            ? "Vendor Name | Name | Templates"
            : pathname === "/documents/RFI"
              ? "Documents Name | Status | Services | Document Type"
              : pathname === "/Documents/Audit"
                ? "Documents Name | Status | Services | Document Type"
                : pathname === "/Assessment/Calendar"
                  ? "Vendor Name | Locations | Assessment Type"
                  : "";

  const SearchIcon = () => isSearchIcon ? searchIcon ? searchIcon : (
    <button
      type="submit"
      className="h-9 absolute inset-y-0 right-2 flex items-center px-2 text-gray-700 bg-transparent ml-3 border-solid border-l-2 border-gray-300"
      disabled={isLoading}
    >
      <MagnifyingGlassIcon className="h-5 w-5 text-custom-464255-color" />
    </button>
  ) : ''

  return (
    <div
      className={`relative ${marginRight}`}
      style={{ width: width, height: height }}
    >
      <form onSubmit={handleSubmit}>
        {localSearch && !hideBackIcon && (
          <button
            type="button"
            onClick={handleClearSearch}
            className="absolute inset-y-0 left-2 flex items-center text-gray-700 bg-transparent"
          >
            <ArrowLeftIcon
              className="text-black"
              style={{ width: "15px", height: "15px" }}
            />
          </button>
        )}
        <input
          ref={inputRef}
          title={routesSearchAttr}
          type="search"
          value={localSearch}
          placeholder={placeholder}
          onChange={onChange}
          disabled={isLoading}
          className={`w-full h-full py-2 px-8 pr-12 bg-white border-2 border-gray-300 rounded-lg 
                     font-hurme text-sm font-normal text-left placeholder-gray-400 text-black ${className}`}
        />
        <SearchIcon />
      </form>
    </div>
  );
};

export default MainSearchBar;
